/*
    Notification type to icon name
*/

export const notificationIcons = [
    { notificationType: 'FRIEND_REQUEST_MESSAGE', icon: 'plus-circle-filled', color: 'green' },
    { notificationType: 'FRIEND_ACCEPT_MESSAGE', icon: 'check-circle-filled', color: 'green' },
    { notificationType: 'FRIEND_BIRTHDAY', icon: 'birthday-cake-circle-filled', color: 'orange' },
    { notificationType: 'LIKE_PHOTO', icon: 'heart-circle-filled', color: 'red' },
    { notificationType: 'LIKE_COMMENT', icon: 'heart-circle-filled', color: 'red' },
    { notificationType: 'LIKE_POST', icon: 'heart-circle-filled', color: 'red' },
    { notificationType: 'LIKE_ALBUM', icon: 'heart-circle-filled', color: 'red' },
    { notificationType: 'LIKE_TRIP', icon: 'heart-circle-filled', color: 'red' },
    { notificationType: 'LIKE_ENTRY', icon: 'heart-circle-filled', color: 'red' },
    { notificationType: 'COMMENT_PHOTO', icon: 'chat-bubble-circle-filled', color: 'blue' },
    { notificationType: 'COMMENT_POST', icon: 'chat-bubble-circle-filled', color: 'blue' },
    { notificationType: 'COMMENT_ALBUM', icon: 'chat-bubble-circle-filled', color: 'blue' },
    { notificationType: 'COMMENT_TRIP', icon: 'chat-bubble-circle-filled', color: 'blue' },
    { notificationType: 'COMMENT_REPLY', icon: 'chat-bubble-circle-filled', color: 'blue' },
];
